import { FunctionComponent } from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import { TabProp, Tabs } from '~/components/Tabs'

type TabLabel = 'Blocklist'

const tabLabelToPath: { [key in TabLabel]: string } = {
  Blocklist: 'blocklist',
}
const blockingListTab: TabProp = { iconName: 'block', label: 'Blocklist', trackingLabel: 'settings-blocklist-tab-apply' }

export const AdQualityTabs: FunctionComponent = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const adQualityTabs: TabProp[] = [blockingListTab]
  const tabLabelFromLocation = (Object.keys(tabLabelToPath) as Array<keyof typeof tabLabelToPath>).find(
    (key) => tabLabelToPath[key] === (location.pathname.split('/').find((dir) => Object.values(tabLabelToPath).includes(dir)) ?? 'blocklist')
  )
  const activeTab: TabLabel = tabLabelFromLocation ?? 'Blocklist'

  return (
    <>
      <div className="mb-5 [&_span_svg]:h-4! [&_span_svg]:w-auto">
        <Tabs
          tabs={adQualityTabs.map((t) => ({ ...t, active: t.label === activeTab }))}
          onClick={(tab) => {
            navigate(tabLabelToPath[tab.label as TabLabel])
          }}
        />
      </div>
      <Outlet />
    </>
  )
}
